<template>
  <div class="checkbox-group-modal" v-if="showModal">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Manage Checkbox Groups</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <table class="table table-bordered table-striped table-hover table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Label</th>
            <th>Help Text</th>
            <th># Fields</th>
            <!-- <th>Max Checked</th> -->
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(group, index) in groups" :key="index" v-if="group.checkboxes !== undefined">
            <td>{{ group.name }}</td>
            <td>{{ group.title }}</td>
            <td>{{ group.desc }}</td>
            <td>{{ Object.keys(group.checkboxes).length }}</td>
            <!-- <td>{{ $store.getters.fieldGroupMaxFields(group.fieldId) }} -->
            <td>
              <button class="btn btn-sm btn-light" @click="editGroup(index)">Edit</button>
              <button class="btn btn-sm btn-danger" @click="deleteGroup(index)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="button-box float-right mb-3 mr-0">
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkbox-group-modal',

  data () {
    return {
      showModal: false,
      groups: {}
    }
  },

  created () {
    let that = this
    this.$on('showModal', function (fieldData) {
      that.showModal = true
      that.groups = JSON.parse(JSON.stringify(that.$store.getters.chGroupFields()))
    })
  },

  methods: {
    closeModal () {
      this.showModal = false
    },

    editGroup (index) {
      this.$bus.emit('checkboxGroupEditModal', index)
      this.showModal = false
    },

    deleteGroup (groupId) {
      window.swal({
        title: 'Delete Checkbox Group?',
        text: 'You are about to delete this checkbox group. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (deleted) {
          this.$store.commit('removeCheckboxGroup', groupId)
          this.$store.dispatch('saveTemplate')
          let groupsExist = this.groups
          delete groupsExist[groupId]
          this.groups = {}
          this.groups = groupsExist
          if (Object.keys(this.groups).length === 0) this.showModal = false
          this.$bus.emit('reloadQuestionnaire')
        }
      })
    }
  },

  beforeDestroy () {
    this.$off('showModal')
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-group-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    max-width: 1700px;
    min-height: 400px;
    max-height: 460px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    .btn {
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/CheckboxGroupModal.vue